/**
 * User requests
 */
import API from '@/api/base.js';
export default {

    login(credentials){
        return API.post('/appuser/login',credentials,'Login',true);
    },
    loginWithQR(qrData){
        return API.post('/appuser/qrlogin',qrData,'QRLogin',true);
    },
    getPlayer(data){
        return API.get('/appuser/getplayer',data,'Player');
    },
    register(data){
        return API.post('/appuser/register',data,'Register', true);
    },
    getUserById(id,data){
        return API.get(`/user/${id}`,data,'Get');
    },
    updateUser(data){
        let id=(data)?data.id:null;
        return API.post(`/user/${id}`,data,'Update');
    },
    changePassword(data){
        return API.post(`/appuser/requestpasswordreset`,data,'Change password',true);
    },
    logout(){
        localStorage.removeItem('selectedEvent');
        return new Promise((resolve) => {resolve()});
    }
}
